export default __webpack_public_path__ + "static/media/Maidenhair-Fern_R2.92d10df6.png";